<template>
  <div v-if="hasError" class="error-boundary">
    <div class="error-container">
      <div class="error-icon">⚠️</div>
      <h2 class="error-title">出现了一个错误</h2>
      <div class="error-details">
        <p class="error-message">{{ errorMessage }}</p>
        <details class="error-stack">
          <summary>错误详情</summary>
          <pre>{{ errorStack }}</pre>
        </details>
      </div>
      <div class="error-actions">
        <button @click="retry" class="btn-primary">重试</button>
        <button @click="reload" class="btn-secondary">刷新页面</button>
      </div>
    </div>
  </div>
  <slot v-else />
</template>

<script setup>
import { ref, onErrorCaptured, onMounted } from 'vue'

const hasError = ref(false)
const errorMessage = ref('')
const errorStack = ref('')

// 捕获子组件错误
onErrorCaptured((error, instance, info) => {
  console.error('🚨 ErrorBoundary捕获错误:', error)
  console.error('🚨 错误信息:', info)
  console.error('🚨 组件实例:', instance)
  
  hasError.value = true
  errorMessage.value = error.message || '未知错误'
  errorStack.value = error.stack || '无堆栈信息'
  
  // 返回false阻止错误继续传播
  return false
})

// 重试函数
const retry = () => {
  hasError.value = false
  errorMessage.value = ''
  errorStack.value = ''
}

// 刷新页面
const reload = () => {
  window.location.reload()
}

onMounted(() => {
  console.log('✅ ErrorBoundary组件已挂载')
})
</script>

<style scoped>
.error-boundary {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 2rem;
}

.error-container {
  max-width: 600px;
  text-align: center;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.error-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #dc2626;
  margin-bottom: 1rem;
}

.error-details {
  text-align: left;
  margin-bottom: 2rem;
}

.error-message {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 4px;
  padding: 1rem;
  color: #dc2626;
  margin-bottom: 1rem;
}

.error-stack {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 1rem;
}

.error-stack summary {
  cursor: pointer;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.error-stack pre {
  font-size: 0.875rem;
  color: #6b7280;
  white-space: pre-wrap;
  word-break: break-word;
}

.error-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn-primary {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-secondary {
  background: #6b7280;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}

.btn-secondary:hover {
  background: #4b5563;
}
</style>